<template>
  <div>
    <q-header class="bg-navbar text-black" height-hint="98">
      <q-toolbar class="q-pr-none">
        <q-toolbar-title>
          <div
            class="xs-hide sm-hide"
            style="width: 200px; height: auto; margin-left: 10px"
          >
            <img
              :src="logo"
              class="img-fluid cursor-pointer"
              style="width: 80% !important"
              @click="routerGo('newrequest')"
            />
          </div>
          <div
            style="width: 120px; height: auto; margin-left: 10px"
            class="md-hide lg-hide xl-hide"
          >
            <img
              :src="logo"
              class="img-fluid cursor-pointer"
              style="height: auto !important"
              @click="routerGo('newrequest')"
            />
          </div>
        </q-toolbar-title>
        <q-btn
          push
          rounded
          label="Preguntas Frecuentes"
          :size="$q.screen.xs ? 'sm' : ''"
          class="q-ma-sm button-preguntas"
          @click="routerGo('preguntasFrecuentes')"
        />

        <q-btn
          push
          rounded
          class="q-ma-sm xs-hide sm-hide button-empleos"
          label="Buscar empleos"
          style="font-family: 'Font-principal Medium'"
          @click="routerGo('newemployment')"
          v-if="$store.state.settings.empresas"
        />
        <q-btn
          push
          rounded
          class="q-ma-sm xs-hide sm-hide button-consultar"
          label="Consultar solicitud"
          style="font-family: 'Font-principal Medium'"
          @click="routerGo('consultar')"
          v-if="!isUserLogged"
        />
        <q-btn-dropdown
          v-if="isUserLogged"
          flat
          no-caps
          class="full-height md-hide lg-hide xl-hide"
          style="font-family: 'Font-principal Medium'"
          color="principal"
          icon="account_circle"
        >
          <q-list>
            <q-item
              clickable
              v-close-popup
              @click="routerGo('myrequests')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="list" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.my_requests") }} </q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              clickable
              v-close-popup
              @click="routerGo('newrequest')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="add_circle_outline" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> Nueva Solicitud </q-item-label>
              </q-item-section>
            </q-item>
            <!-- <q-item
              clickable
              v-close-popup
              @click="routerGo('consultar')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="search" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.find") }} </q-item-label>
              </q-item-section>
            </q-item> -->
            <q-item
              clickable
              v-close-popup
              @click="routerGo('preguntasFrecuentes')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="help" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> Preguntas Frecuentes </q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              clickable
              v-close-popup
              @click="routerGo('configuracion')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="settings" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.settings") }} </q-item-label>
              </q-item-section>
            </q-item>

            <q-item
              clickable
              v-close-popup
              @click="routerGo('cambiarpassword')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="lock" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ $t("myaccount.change_password") }}
                </q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable v-close-popup @click="logout" v-if="isUserLogged">
              <q-item-section avatar>
                <q-icon color="principal" name="logout" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.logout") }} </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
        <q-btn
          push
          color="principal"
          class="q-ma-sm"
          style="border-radius: 10px"
          outline
          :size="$q.screen.xs ? 'sm' : ''"
          label="Iniciar sesión"
          @click="routerGo('login')"
          v-if="!isUserLogged"
        />
        <div class="row justify-end navbar-tab xs-hide sm-hide user-active">
          <q-btn-dropdown
            no-caps
            icon="account_circle"
            class="q-px-md full-height"
            v-if="isUserLogged"
            flat
          >
            <template v-slot:label>
              <div class="q-ml-md">
                <div>
                  {{ $t("navbar.welcome") }}
                  <br />
                  {{ userName }}
                </div>
              </div>
            </template>
            <q-list>
              <q-item
                clickable
                v-close-popup
                @click="routerGo('myrequests')"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon color="principal" name="list" size="xs" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    {{ $t("navbar.my_requests") }}
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
                @click="routerGo('newrequest')"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon
                    color="principal"
                    name="add_circle_outline"
                    size="xs"
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label> Nueva Solicitud </q-item-label>
                </q-item-section>
              </q-item>
              <!-- <q-item
                clickable
                v-close-popup
                @click="routerGo('consultar')"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon color="principal" name="search" size="xs" />
                </q-item-section>
                <q-item-section>
                  <q-item-label> {{ $t("navbar.find") }} </q-item-label>
                </q-item-section>
              </q-item> -->
              <q-item
                clickable
                v-close-popup
                @click="routerGo('configuracion')"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon color="principal" name="settings" size="xs" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    {{ $t("navbar.data_settings") }}
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
                @click="routerGo('cambiarpassword')"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon color="principal" name="lock" size="xs" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    {{ $t("myaccount.change_password") }}
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
                @click="logout"
                v-if="isUserLogged"
              >
                <q-item-section avatar>
                  <q-icon color="principal" name="logout" size="xs" />
                </q-item-section>
                <q-item-section>
                  <q-item-label> {{ $t("navbar.logout") }} </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>
      </q-toolbar>
    </q-header>
    <!-- <q-header class="bg-white text-black">
      <q-toolbar class="bg-navbar text-black ">
        <q-btn
          class="lt-md q-mx-lg xs-hide sm-hide"
          icon="menu"
          @click="right = !right"
        ></q-btn>

        <q-toolbar-title class="cursor-pointer xs-hide sm-hide">
          <div
            style="width: 200px; height: auto; margin-left: 10px; margin-top: 20px;"
          >
            <img
              :src="logo"
              class="img-fluid cursor-pointer"
              style="height:auto !important; "
              @click="routerGo('newrequest')"
            />
          </div>
        </q-toolbar-title>
        <div
          style="width: 140px; height: auto; margin-left: 10px; margin-top: 20px;"
          class="md-hide lg-hide xl-hide"
        >
          <img
            :src="logo"
            class="img-fluid cursor-pointer"
            style="height:auto !important; "
            @click="routerGo('newrequest')"
          />
        </div>
        <q-space />

        <q-btn
          push
          rounded
          class="q-ma-sm xs-hide sm-hide button-consultar"
          label="Consultar Solicitudes"
          @click="routerGo('consultar')"
        />
        <q-btn
          push
          rounded
          color="principal"
          outline
          class="q-ma-sm"
          label="Ingresar"
          @click="routerGo('login')"
          v-if="!isUserLogged"
        />

        <q-btn-dropdown
          no-caps
          class="full-height user-active"
          v-if="isUserLogged"
          flat
        >
          <template v-slot:label>
            <div class="row items-center no-wrap">
              <div class="text-left">
                {{ $t("navbar.welcome") }}
                <br />
                {{ userName }}
              </div>
            </div>
          </template>
          <q-list>
            <q-item
              clickable
              v-close-popup
              @click="routerGo('myrequests')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="list" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.my_requests") }} </q-item-label>
              </q-item-section>
            </q-item>
            <q-item
              clickable
              v-close-popup
              @click="routerGo('myaccount')"
              v-if="isUserLogged"
            >
              <q-item-section avatar>
                <q-icon color="principal" name="settings" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.settings") }} </q-item-label>
              </q-item-section>
            </q-item>

            <q-item clickable v-close-popup @click="logout" v-if="isUserLogged">
              <q-item-section avatar>
                <q-icon color="principal" name="logout" size="xs" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ $t("navbar.logout") }} </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </q-toolbar>
    </q-header> -->
    <q-drawer
      v-if="$q.screen.lt.md"
      v-model="right"
      side="left"
      bordered
      overlay
    >
      <q-tabs no-caps :value="tab" vertical>
        <div>
          <div v-if="isUserLogged" class="q-my-lg">
            <div class="row flex-center items-center no-wrap q-mb-md">
              <div class="navbar-tab text-center">
                {{ $t("navbar.welcome") }}
                <br />
                {{ userName }}
              </div>
            </div>
            <q-route-tab
              class="navbar-tab"
              :to="{ name: 'configuracion' }"
              :label="$t('navbar.data_settings')"
              @click.native="closeDrawer('configuracion')"
            />

            <q-route-tab
              class="navbar-tab"
              :to="{ name: 'myrequests' }"
              :label="$t('navbar.my_requests')"
              @click.native="closeDrawer('my_requests')"
            />

            <q-route-tab
              class="navbar-tab"
              :to="{ name: 'mypostulations' }"
              label="Mis Postulaciones"
              @click.native="closeDrawer('my_postulations')"
            />
            <q-route-tab
              class="navbar-tab"
              :to="{ name: 'requestdetails' }"
              label="Consulta Estado"
              @click.native="closeDrawer('requestdetails')"
            />
            <q-tab class="navbar-tab" @click="logout" label="Desconectarme" />
          </div>
          <div v-else>
            <q-route-tab
              class="navbar-tab"
              :to="{ name: 'login' }"
              :label="$t('navbar.login')"
              @click.native="closeDrawer('login')"
            />
          </div>
        </div>

        <q-route-tab
          v-if="!isUserLogged"
          class="navbar-tab"
          :to="{ name: 'register' }"
          :label="$t('navbar.register')"
          @click.native="closeDrawer('register')"
        />
      </q-tabs>
    </q-drawer>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component
export default class TheNavbar extends Vue {
  private logo = process.env.VUE_APP_AWS_ASSETS + "/logos/logo-uno.png";
  private right: Boolean = false;
  private get tab(): String {
    return this.$router.currentRoute.name!;
  }
  private get userName(): String {
    return (
      this.$store.state.user.name +
      " " +
      this.$store.state.user.father_last_name
    );
  }

  private closeDrawer(route: string) {
    if (this.$router.currentRoute.name == route) {
      this.$router.go(0);
    }
    this.right = false;
  }

  private get isUserLogged(): String {
    return this.$store.state.logged;
  }
  private logout(): void {
    window.location.href =
      "https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout";
    this.$store.dispatch("logout");
    this.right = false;
    this.$store.state.ticket.step = 0;
    this.$router.push({ name: "newrequest" });
  }

  private routerGo(name: any) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch((err) => {
          this.$q.notify({
            message: "Ha ocurrido un error",
            color: "principal",
            position: "top",
            timeout: 5000,
          });
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/colores";
.logo {
  padding-left: 10px;
  height: 75px;
}
.left-border {
  background-image: linear-gradient(grey, grey), linear-gradient(white, white);
  background-repeat: no-repeat;
  background-size: 1px 30%, calc(100% - 4px) 100%;
  background-position: left center, 4px 0;
}
.navbar-tab {
  font-family: "Font-principal Light";
  font-size: 14px;
  color: grey;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.bg-navbar {
  background-color: #f5f5f5;
}

.button-consultar {
  background-color: $color-primario-uno;
  color: #ffffff;
  font-family: "Font-principal Medium";
}

.button-empleos {
  background-color: $color-primario-dos;
  color: #ffffff;
  font-family: "Font-principal Medium";
}

.button-preguntas {
  background-color: $color-primario-dos;
  color: #ffffff;
  font-family: "Font-principal Medium";
}

.user-active {
  background-color: $color-primario-uno;
  color: #ffffff;
  font-weight: bold;
  font-family: "Font-principal";
  height: 79px;
}
</style>
